import React, { useState } from 'react';

import { useFiltro } from '../../../../../contexts/FilaEmbarque/Filtro/hooks/useFiltro';
import {
  Button,
  ButtonAmanha,
  ButtonExtraStyle,
  ButtonHoje,
  Col,
  RangePicker,
  Row,
  Styles,
} from './styles';

const FiltroData = () => {
  const FORMATO_DATA = 'DD/MM/YYYY';
  const [datePickerValue, setDatePickerValue] = useState([null, null]);
  const {
    filtro,
    setDatePicker,
    setFiltroAmanha,
    setFiltroHoje,
    setFiltroOntem,
  } = useFiltro();

  const onChangePeriodo = async data => {
    if (!data) {
      setDatePickerValue([null, null]);
      return;
    }

    const [inicio, fim] = data;
    setDatePickerValue([
      inicio ? inicio.startOf('day').utc() : null,
      fim ? fim.endOf('day').utc() : null,
    ]);

    if (inicio && fim) {
      setDatePicker({
        periodo: 'custom',
        dataInicial: inicio.startOf('day').utc(),
        dataFinal: fim.endOf('day').utc(),
      });
    }
  };

  const clearDatePickerValue = () => {
    setDatePickerValue([null, null]);
  };

  return (
    <Row>
      <Col>
        <Styles />
        <Button
          style={ButtonExtraStyle}
          className={filtro.periodo === 'ontem' ? 'btnAtivo' : 'btnInativo'}
          onClick={() => {
            setFiltroOntem();
            clearDatePickerValue();
          }}
        >
          Ontem
        </Button>
        <ButtonHoje
          className={filtro.periodo === 'hoje' ? 'btnAtivo' : 'btnInativo'}
          onClick={() => {
            setFiltroHoje();
            clearDatePickerValue();
          }}
        >
          Hoje
        </ButtonHoje>
        <ButtonAmanha
          className={filtro.periodo === 'amanha' ? 'btnAtivo' : 'btnInativo'}
          onClick={() => {
            setFiltroAmanha();
            clearDatePickerValue();
          }}
        >
          Amanhã
        </ButtonAmanha>

        <RangePicker
          value={datePickerValue}
          onCalendarChange={onChangePeriodo}
          format={FORMATO_DATA}
        />
      </Col>
    </Row>
  );
};

export default FiltroData;
